import { useCallback } from 'react';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { exportContentWhiteboard } from 'features/content-whiteboard/utils/exportContentWhiteboard';
import { useContentBoard } from 'features/content-whiteboard/hooks/useContentBoard';
import { useContentWhiteboard } from 'features/content-whiteboard/useContentWhiteboard';
import { useAppSelector } from 'store/hooks';
import { selectGridPanel } from 'features/layout/features/content/contentSlice';
import {
  selectContentLibraryOpenedFile,
  selectSharedFileById,
} from 'features/content-library/contentLibrarySlice';
import { CONTENT_BOARD_SUPPORTED_FILE_TYPES } from 'features/content-whiteboard/constants';
import { useTranslation } from 'react-i18next';
import { useContentLibrary } from 'features/content-library/useContentLibrary';

export const useContentWhiteboardExportControl = () => {
  const { isFeatureAvailable, canEditContent } = useContentWhiteboard();
  const currentGridPanel = useAppSelector(selectGridPanel);
  const openedFile = useAppSelector(selectContentLibraryOpenedFile);
  const contentBoard = useContentBoard();

  const { canManageLibrary } = useContentLibrary();
  const sharedFile = useAppSelector(
    (state) => openedFile && selectSharedFileById(state, openedFile.id)
  );

  const canManageFile = canManageLibrary || !!sharedFile;

  const { t } = useTranslation('content-whiteboard');

  const handleClick = useCallback(async () => {
    try {
      if (!contentBoard.editor) {
        return;
      }

      await exportContentWhiteboard({ editor: contentBoard.editor });
    } catch (e) {
      console.log('Export failed: ', e);
    }
  }, [contentBoard]);

  const isSupportedFileType =
    openedFile &&
    currentGridPanel === 'contentLibrary' &&
    CONTENT_BOARD_SUPPORTED_FILE_TYPES.includes(openedFile.type);

  return {
    controlEnabled: isFeatureAvailable && (canEditContent || canManageFile) && isSupportedFileType,
    handleClick,
    tooltip: t('actions.export_draw'),
  };
};

export const ContentWhiteboardExportControl = () => {
  const { handleClick, tooltip } = useContentWhiteboardExportControl();
  return <GridPanelControl tooltip={tooltip} icon="download" onClick={handleClick} />;
};
